import { SearchQuoteRequestLineDto } from "#modules/quoteRequestLines/fetchQuoteRequestLines.api";
import { QuoteResquestLineWithBatchInfo } from "#modules/quoteRequestLines/QuoteRequestLines.page";
import { sortQuoteRequestLines } from "shared";

const mapSearchQrlDtoToQrlDtoWithBatchInfo = (
  qrlSearch: SearchQuoteRequestLineDto,
): QuoteResquestLineWithBatchInfo => ({
  ...qrlSearch,
  quoteRequest: {
    ...qrlSearch.quoteRequest,
  },
  processSteps: qrlSearch.processSteps.map((ps) => ({
    ...ps,
    productLines: ps.productLines ?? [],
    companyMachine: null,
    materialLayout: null,
  })),
  part: {
    ...qrlSearch.part,
    files: qrlSearch.part.files ?? [],
  },
  layout: qrlSearch.layout
    ? {
        ...qrlSearch.layout,
        materialLayout: qrlSearch.layout.materialLayout ?? null,
      }
    : null,
  productLines: [],
  cluster: null,
  batch: null,
  isBatch: false,
  latestPredictionJob: null,
});

export const groupSearchQuoteRequestLinePerBatch = (
  quoteRequestLines: SearchQuoteRequestLineDto[],
) => {
  const qrls: QuoteResquestLineWithBatchInfo[] = [];
  const { batches } = sortQuoteRequestLines(
    quoteRequestLines.map(mapSearchQrlDtoToQrlDtoWithBatchInfo),
  );

  batches.forEach((group) => {
    const groupFirstElem = group[0];

    if (!groupFirstElem) {
      return;
    }

    if (group.length > 1) {
      qrls.push({
        ...groupFirstElem.quoteRequestLine,
        isBatch: true,
      });
      return;
    }

    qrls.push(groupFirstElem.quoteRequestLine);
  });

  return qrls;
};
